import { THashPath } from "./Routes";
import { _APP_DATA } from "../data/AppData";
import { _GetCleanHash, _GetHashInfo, _HistoryBackEvalAndTry, _NavigationHashController } from "./Router";

export async function OnHashChangeController() {
    let hash: string = window.location.hash
    hash = hash.replace("#", "");
    const hashPath = hash as THashPath;

    if ((!_APP_DATA || !_APP_DATA.userData) && hashPath != "login") {
        _HashReplace("login");
        return;
    }

    if (_APP_DATA.userData && (!hashPath || hashPath == "login")) {
        _HashReplace("default")
        return;
    }
    await _NavigationHashController(hashPath);
}

type TComplexHashPath = THashPath | "#" | { [k in THashPath]: `#${k}` }[THashPath]

export function _HashAssign(hash: TComplexHashPath | "default") {
    hash == "default" && (hash = (_APP_DATA.userData.IdGrupo ? "home" : "groups"));

    if (!hash.startsWith("#")) hash = "#" + hash as TComplexHashPath;
    window.location.assign(hash);
}

export function _HashReplace(hash: TComplexHashPath | "default") {
    hash == "default" && (hash = (_APP_DATA.userData.IdGrupo ? "home" : "groups"));

    if (!hash.startsWith("#")) hash = "#" + hash as TComplexHashPath;
    window.location.replace(hash);
}

export function _HistoryBack() {
    window.history.back();
}

export function _ReplaceState(hash: TComplexHashPath, objData: any, evalHashChange = true) {
    const valueHash = (!hash.startsWith("#") ? "#" : "") + hash;
    history.replaceState(objData, hash, valueHash);
    evalHashChange && OnHashChangeController();
}

export function _PushState(hash: TComplexHashPath, objData: any) {
    const valueHash = (!hash.startsWith("#") ? "#" : "") + hash;
    history.pushState(objData, hash, valueHash);
    OnHashChangeController();
}
